import { render } from "./VueNuvei.vue?vue&type=template&id=3e231813"
import script from "./VueNuvei.vue?vue&type=script&lang=js"
export * from "./VueNuvei.vue?vue&type=script&lang=js"

import "./VueNuvei.vue?vue&type=style&index=0&id=3e231813&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__